module.exports = __webpack_public_path__ + "static/media/image_36.352ab8be.png";